import { EverifyUserRole } from '@vis-auth/vis-user-client';
import { AccountType } from 'eve-account-client';

interface ConstructorArguments {
  userRoles: EverifyUserRole[];
  accountType: AccountType;
  webServiceAccess: boolean;
}

export default class EveAuthorizationService {
  userRoles: EverifyUserRole[];

  accountType: AccountType;

  webServiceAccess: boolean;

  constructor({ userRoles, accountType, webServiceAccess }: ConstructorArguments) {
    this.userRoles = userRoles;
    this.accountType = accountType;
    this.webServiceAccess = webServiceAccess;
  }

  authorizeCorporatePaths(): boolean {
    return this.accountType === AccountType.CORPORATE && this.userRoles.includes(EverifyUserRole.CORPORATEADMIN);
  }

  authorizeCompanyPaths(): boolean {
    return (
      [AccountType.EMPLOYER, AccountType.AGENCY, AccountType.CHILD].includes(this.accountType) &&
      this.userRoles.includes(EverifyUserRole.PROGRAMADMIN)
    );
  }

  authorizeCasesPaths(): boolean {
    return [AccountType.EMPLOYER, AccountType.AGENCY, AccountType.CHILD].includes(this.accountType);
  }

  authorizeClientPaths(): boolean {
    return this.accountType === AccountType.AGENCY;
  }

  authorizeWebServices(): boolean {
    return this.webServiceAccess === true;
  }
}
